import styles from './style.module.scss';
import { Button, PageHeader } from 'components';
import { PlusOutlined, SearchOutlined } from '@ant-design/icons';
import { Row, Table, Typography } from 'antd';
import { Link, Route, Routes } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import useUserRoles from '../useUserRoles';
import DeleteModal from 'components/deleteModalView';
import EditModal from '../edit';
import { useRecoilValue } from 'recoil';
import { getPage } from '../../../../../../hooks/useUser';

const CompanyCategoriesMainPage = () => {
  const { t } = useTranslation();

  const {
    columns,
    data,
    loading,
    updateInProcess,
    onChangeTableFilter,
    handleDeleteCategory,
    form,
    premisionsGroups,
    handleCreateRole,
    onDelete,
  } = useUserRoles(true);
  const pages = useRecoilValue(getPage);
  return (
    <div>
      <div className={styles.container}>
        {!!data?.user_roles?.length && (
          <Table
            columns={columns}
            dataSource={data.user_roles}
            pagination={data.pagination}
            onChange={onChangeTableFilter}
            loading={loading}
          />
        )}
        {!data?.user_roles?.length && pages?.ability?.can_create && (
          <Row className={styles.emptyRow} justify={'center'}>
            <div className={styles.actionIcon}>
              <SearchOutlined />
            </div>
            <Typography.Title level={4}>
              {t('Nessun ruolo ancora')}
            </Typography.Title>
            <Typography className={styles.textNew} color='red'>
              {t('Сreare un nuovo ruolo ora')}
            </Typography>
            <Link to={'create/new'}>
              <Button width={'191px'} big icon={<PlusOutlined />}>
                {t('Crea un nuovo ruolo')}
              </Button>
            </Link>
          </Row>
        )}
      </div>
      <Routes>
        <Route
          path={'new'}
          element={
            <EditModal
              form={form}
              onClickDelete={handleDeleteCategory}
              loading={updateInProcess}
              premisionsGroups={premisionsGroups}
              handleCreateRole={handleCreateRole}
            />
          }
        />
        <Route
          path={'edit'}
          element={
            <EditModal
              isEdit
              form={form}
              onClickDelete={handleDeleteCategory}
              loading={updateInProcess}
              premisionsGroups={premisionsGroups}
              handleCreateRole={handleCreateRole}
            />
          }
        />
        <Route
          path={'delete'}
          element={
            <DeleteModal onClickDelete={onDelete} loading={updateInProcess} />
          }
        />
      </Routes>
    </div>
  );
};

export default CompanyCategoriesMainPage;
